module.exports = __webpack_public_path__ + "static/media/om_wrinkles_heavy.565de97a.png";